<template>
  <!-- https://floating-vue.starpad.dev/guide/component#dropdown -->
  <FloatingVueDropdown
    ref="popoverRef"
    :distance="distance"
    :triggers="['click']"
    theme="dropdown-menu"
    :placement="placement"
    auto-hide
    @show="onShow"
    @hide="onHide"
    @wheel="onHide"
  >
    <template v-for="(_, slot) in $slots" #[slot]="scope">
      <slot :name="slot" v-bind="scope || {}" />
    </template>
  </FloatingVueDropdown>
</template>

<script>
import { defineComponent, ref, onBeforeUnmount } from 'vue'
import { Dropdown as FloatingVueDropdown } from 'floating-vue'
import 'floating-vue/dist/style.css'

export default defineComponent({
  name: 'VDropdown',
  components: {
    FloatingVueDropdown
  },
  props: {
    itemSelector: {
      type: String,
      default: 'li > a:not(:disabled)'
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    distance: {
      type: Number,
      default: 2
    }
  },

  setup(props) {
    const popoverRef = ref(null)

    const popoverKeydown = e => {
      const popover = popoverRef.value

      if (!popover) {
        return
      }

      if (['ArrowUp', 'ArrowDown'].includes(e.key)) {
        e.preventDefault()

        const items = [...popover.$refs.popperContent.$el.querySelectorAll(props.itemSelector)]

        if (!items.length) {
          return
        }

        let index = items.indexOf(e.target)
        index = e.key === 'ArrowDown' ? index + 1 : index - 1
        items[index]?.focus()
      }

      if ((e.key === 'Enter' || e.key === ' ') && e.target === popover.$refs.popperContent.$el) {
        e.preventDefault()
        popover.hide()
      }
    }

    const onShow = () => {
      document.addEventListener('keydown', popoverKeydown)
    }

    const onHide = () => {
      document.removeEventListener('keydown', popoverKeydown)
      const popover = popoverRef.value
      popover?.$refs.popper.$_targetNodes[0].focus()
    }

    onBeforeUnmount(() => {
      document.removeEventListener('keydown', popoverKeydown)
    })

    return {
      popoverRef,
      onShow,
      onHide
    }
  }
})
</script>

<style>
.v-popper--theme-dropdown-menu .v-popper__arrow-container {
  display: none;
}

.v-popper__popper {
  z-index: 499;
  box-shadow: 0px 0px 18px -8px #696969;
  border-radius: 16px;
}

.v-popper__popper,
.dropbtn {
  font-family: Montserrat, -apple-system, BlinkMacSystemFont, sans-serif !important;
}
</style>
